import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent, NbLoginComponent,
} from '@nebular/auth';
import { AppComponent } from './app.component';
import { SigninComponent } from './components/auth/signin/signin.component';
import { GuestGuard } from './guards/auth.guard';
import { LogoutComponent } from './components/auth/logout/logout.component';
import { CheckUidComponent } from './components/auth/check-uid/check-uid.component';
import { AuthComponent } from './components/auth/auth.component';

const routes: Routes = [
  {
    path: 'pages',
    canActivate: [GuestGuard],
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'auth',
    component: AuthComponent,
    children: [
      {
        path: '',
        component: CheckUidComponent,
      },
      {
        path: 'check-uid/:uid',
        component: CheckUidComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'signin',
        component: NbLoginComponent,
      }
    ],
  },
  // {
  //   path: 'auth',
  //   loadChildren: () => import('./components/auth/auth.module')
  //   .then(m => m.AuthModule),
  // },
  { path: 'home', component: AppComponent},
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
